import Repository from './Repository.js';

class ProgramPartnerGroupsRepository extends Repository {
    async getGroups(query) {
        return await this.get('programPartnerGroups', query);
    }
}

export default new ProgramPartnerGroupsRepository();
